import { AgendaItem } from '../types';

export const agendaItems: AgendaItem[] = [
  {
    id: 'check-in',
    title: 'Check-In',
    description: 'Introduction to Iron Makers Day @ one:demo forge',
    startTime: new Date('2026-02-17T07:15:00.000Z'),
    endTime: new Date('2026-02-17T07:30:00.000Z'),
    additionalInfo: 'Meeting Point Hotel Lobby!'
  },
  {
    id: 'welcome-kickoff',
    title: 'Welcome & Kickoff',
    description: 'Introduction to Iron Makers Day @ one:demo forge',
    startTime: new Date('2026-02-17T07:30:00.000Z'),
    endTime: new Date('2026-02-17T08:00:00.000Z')
  },
  {
    id: 'infrastructure-rally',
    title: 'Infrastructure Rally',
    description: 'Forging the iron - Provide the Infrastructure',
    startTime: new Date('2026-02-17T08:00:00.000Z'),
    endTime: new Date('2026-02-17T09:00:00.000Z'),
    additionalInfo: 'First team - first choice!',
    requiresTeams: true
  },
  {
    id: 'coffee-break-1',
    title: 'Coffee Break 1',
    description: 'Refuel and recharge',
    startTime: new Date('2026-02-17T09:00:00.000Z'),
    endTime: new Date('2026-02-17T09:15:00.000Z'),
    additionalInfo: 'Within the hotel.'
  },
  {
    id: 'service-session-1',
    title: 'Service Session 1',
    description: 'Build your solution',
    startTime: new Date('2026-02-17T09:15:00.000Z'),
    endTime: new Date('2026-02-17T11:00:00.000Z'),
    requiresTeams: true,
    requiresCycle: true
  },
  {
    id: 'lunch-break',
    title: 'Lunch Break',
    description: 'Refuel and recharge',
    startTime: new Date('2026-02-17T11:00:00.000Z'),
    endTime: new Date('2026-02-17T11:45:00.000Z'),
    additionalInfo: 'Cafeteria - Lunch provided'
  },
  {
    id: 'service-session-2',
    title: 'Service Session 2',
    description: 'Continue building',
    startTime: new Date('2026-02-17T11:45:00.000Z'),
    endTime: new Date('2026-02-17T13:15:00.000Z'),
    requiresTeams: true,
    requiresCycle: true
  },
  {
    id: 'coffee-break-2',
    title: 'Coffee Break 2',
    description: 'Refuel and recharge',
    startTime: new Date('2026-02-17T13:15:00.000Z'),
    endTime: new Date('2026-02-17T13:45:00.000Z'),
    additionalInfo: 'Out of the hotel.'
  },
  {
    id: 'service-session-3',
    title: 'Service Session 3',
    description: 'Continue building',
    startTime: new Date('2026-02-17T13:45:00.000Z'),
    endTime: new Date('2026-02-17T15:15:00.000Z'),
    requiresTeams: true
  },
  {
    id: 'outro',
    title: 'Outro',
    description: 'Summarize the Day',
    startTime: new Date('2026-02-17T15:15:00.000Z'),
    endTime: new Date('2026-02-17T15:30:00.000Z'),
    additionalInfo: 'Wrap up - clean up - get up'
  }
];
